"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateHours24 = exports.validateTimeObject = exports.validateString24hr = exports.validateString12hr = void 0;
var is_1 = require("../is/is");
var writeBadValue = function (badValue) {
    if (typeof badValue === 'string') {
        return "\"" + badValue + "\"";
    }
    if (badValue === null) {
        return 'null';
    }
    if (badValue === undefined) {
        return 'undefined';
    }
    return badValue;
};
exports.validateString12hr = function (string12hr) {
    if (!is_1.isString12hr(string12hr)) {
        throw new Error("\"" + string12hr + "\" is not a valid 12 hour time, use the format \"HH:MM AM/PM\"");
    }
    return true;
};
exports.validateString24hr = function (string24hr) {
    if (!is_1.isString24hr(string24hr)) {
        var extra = (/-/.test(string24hr) &&
            ' Use an empty string instead of "--:--" to represent a blank value') ||
            (/24:\d\d/.test(string24hr) && ' Use "00" instead of "24".') ||
            '';
        throw new Error("\"" + string24hr + "\" is not a valid 24 hour time." + extra);
    }
    return true;
};
exports.validateTimeObject = function (timeObject) {
    var hrs24 = timeObject.hrs24, hrs12 = timeObject.hrs12, minutes = timeObject.minutes, mode = timeObject.mode;
    if (!is_1.isTimeObject(timeObject)) {
        throw new Error(JSON.stringify(timeObject) + " is not a valid time object. Must be in the format {hrs24: 0, hrs12: 12, minutes: 0, mode: 'AM'} (12:00 AM)");
    }
    var isValid = function (variable, varName, lower, upper) {
        if ((typeof variable === 'string' && variable !== '--') ||
            (typeof variable === 'number' && (variable > upper || variable < lower))) {
            var badValue = writeBadValue(variable);
            throw new Error(varName + " (" + badValue + ") is invalid, \"" + varName + "\" must be a number " + lower + "-" + upper + " or null");
        }
    };
    isValid(hrs24, 'hrs24', 0, 23);
    isValid(hrs12, 'hrs12', 1, 12);
    isValid(minutes, 'minutes', 0, 59);
    var validModes = ['AM', 'PM', null];
    if (validModes.indexOf(mode) < 0) {
        throw new Error("Mode (" + writeBadValue(mode) + ") is invalid. Valid values are: " + validModes
            .map(function (val) { return writeBadValue(val); })
            .join(', '));
    }
    if (hrs24 !== null && hrs12 === null) {
        throw new Error("hrs12 (" + hrs12 + ") must not be null if hrs24 (" + hrs24 + ") has a value");
    }
    if ((hrs24 === 0 && hrs12 !== 12) ||
        (hrs24 !== null && hrs12 !== hrs24 && hrs24 < 13 && hrs24 !== 0) ||
        (typeof hrs24 === 'number' && hrs24 > 12 && hrs12 !== hrs24 - 12)) {
        throw new Error("hrs12 (" + hrs12 + ") should be equal to or 12 hours behind hrs24 (" + hrs24 + ")");
    }
    if (mode !== null &&
        ((hrs24 && hrs24 >= 12 && mode !== 'PM') || (hrs24 && hrs24 <= 11 && mode !== 'AM'))) {
        if (mode === 'PM') {
            throw new Error("If mode (" + mode + ") is \"PM\", hrs24 (" + hrs24 + ") should be greater than or equal to 12");
        }
        else {
            throw new Error("If mode (" + mode + ") is \"AM\", hrs24 (" + hrs24 + ") should be less than or equal to 11");
        }
    }
    if (mode === null && hrs24 !== null) {
        throw new Error("If mode is null, hrs24 (" + hrs24 + ") must be null as well. It is not possible to know the correct hrs24 value if mode is null");
    }
    if (mode !== null && hrs12 !== null && hrs24 === null) {
        throw new Error("If mode (" + mode + ") and hrs12 (" + hrs12 + ") are defined then hrs24 (" + hrs24 + ") must be defined as well");
    }
    return true;
};
exports.validateHours24 = function (hrs24) {
    if ((typeof hrs24 !== 'number' && hrs24 !== '--') ||
        (typeof hrs24 === 'number' && (hrs24 < 0 || hrs24 > 23))) {
        throw new Error("\"" + hrs24 + "\" must be a number between 0 and 23 or null, use 0 instead of 24");
    }
    return true;
};
